// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".batchNumber[data-v-3982f9c8] {\n  color: #007efd;\n  cursor: pointer;\n}\n.remarkStyle p[data-v-3982f9c8] {\n  padding: 0 !important;\n  margin: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
